import { createHead } from '@unhead/vue'

export function install(app) {
  const head = createHead()
  app.use(head)
}
